import { yupResolver } from "@hookform/resolvers/yup";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import * as Yup from "yup";
import { SdsForm } from "soft_digi";
import { ROLE_URLS } from "../../api/AdminUrls";
import { useSiteContext } from "../../contexts/SiteProvider";
import { showAlertAutoClose } from "../../services/notifyService";
import { user_get_select } from "../../services/site/SelectBoxServices";
import { post } from "../../services/smartApiService";

import { SdsFormElementProps } from "soft_digi/dist/sdforms/SdsFromInterFace";
interface HeaderProps {
  loadTableData: () => void;
  dataIn: any;
}
const schema = Yup.object({
  role_name: Yup.string()
    .required("Role Name is required")
   ,
  
  users: Yup.array()
    .min(1, "At least one user must be selected")
    .required("Users selection is required"),
});

const RoleForm: React.FC<HeaderProps> = ({ loadTableData, dataIn }) => {
  const { closeModal } = useSiteContext();
  const [allUsers, setAllUsers] = useState([]);
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: dataIn,
    resolver: yupResolver(schema),
  });

  useEffect(() => {
    user_get_select((data: any) => setAllUsers(data));
  }, []);

  const onSubmit = (formData: any) => {
    let url = ROLE_URLS.INSERT;
    if (formData.ID !== undefined) {
      formData["id"] = formData.ID;
      url = ROLE_URLS.UPDATE;
    }

    const subscription = post(url, formData).subscribe((response) => {
      loadTableData();
      showAlertAutoClose("Data Saved Successfully", "success");
      closeModal();
    });
    return () => {
      subscription.unsubscribe();
    };
  };

  const formElements: SdsFormElementProps[] = [
    {
      type: "TEXT_BOX",
      width: 12,
      name: "role_name",
      element: {
        label: "Role Name",
        isRequired: true,
        // inputProps: { isFocussed: true },
        inputType: "BORDER_LABEL",
      },
    },

    {
      type: "SELECT_BOX",
      width: 12,
      name: "users",
      element: {
        label: "Users",
        isMulti: true,
        inputType: "BORDER_LABEL",
        options: allUsers,
      },
    },
    {
      type: "LABEL",
      width: 7,
      name: "label",
    },
    {
      type: "BUTTON",
      width: 2,
      name: "submit_button",
      class_name: "has-text-right",
      element: {
        classList: ["button", "smart-third-button"],
        label: "Close",
        onClick: closeModal,
      },
    },
    {
      type: "BUTTON",
      width: 2,
      name: "submit_button",
      element: {
        classList: ["button", "smart-action-button"],
        label: dataIn.ID ? "Update" : "Add",
        onClick: handleSubmit(onSubmit),
      },
    },
  ];
  return (
    <>
      <div className="sd-efl-input">
        <SdsForm elements={formElements} errors={errors} control={control} />
      </div>
    </>
  );
};

export default RoleForm;
